import { render, staticRenderFns } from "./contest-admin.vue?vue&type=template&id=27cab5f2&scoped=true"
import script from "./contest-admin.vue?vue&type=script&lang=js"
export * from "./contest-admin.vue?vue&type=script&lang=js"
import style0 from "./contest-admin.vue?vue&type=style&index=0&id=27cab5f2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cab5f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27cab5f2')) {
      api.createRecord('27cab5f2', component.options)
    } else {
      api.reload('27cab5f2', component.options)
    }
    module.hot.accept("./contest-admin.vue?vue&type=template&id=27cab5f2&scoped=true", function () {
      api.rerender('27cab5f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/detail-pane/contest-admin.vue"
export default component.exports